import { array } from "../helpers"
import Flex from "./utils/Flex"
import Container from './utils/Container'
import MyDay from '../assets/images/my-day.png'
import ProfileThumbnail from '../assets/images/profile-thumb.png'


const Stories = () => {
	return (
		<div className="py-3 bg-secondary2">
			<Container>
				<Flex id="story" className="space-x-2 md:space-x-4 lg:space-x-8 2xl:space-x-12 overflow-hidden">
					<div className="text-center w-max flex-none">
						<div className="relative rounded lg:rounded-xl 2xl:rounded-3xl overflow-hidden">
							<img
								className="w-12 h-12 md:w-16 md:h-16 lg:w-20 lg:h-20 2xl:w-24 2xl:h-24 object-cover object-center mx-auto"
								src={ProfileThumbnail}
								alt="Profile thumbnail"
							/>
							<div
								className="bg-black bg-opacity-30 flex cursor-pointer items-center justify-center absolute inset-0 font-bold text-3xl md:text-4xl lg:text-5xl 2xl:text-6xl text-primary"
							>
								+
							</div>
						</div>
						<p
							className="mt-1 2xl:mt-3 text-xs lg:text-base 2xl:text-xl md:font-bold"
						>
							Your Story
						</p>
					</div>
					{array.empty(10).map(i => (
						<div key={i} className="text-center w-max flex-none">
							<img
								src={MyDay}
								alt="User Story"
								className="w-12 h-12 md:w-16 md:h-16 lg:w-20 lg:h-20 2xl:w-24 2xl:h-24 rounded lg:rounded-xl 2xl:rounded-3xl object-cover object-center mx-auto"
							/>
							<p
								className="mt-1 2xl:mt-3 text-xs lg:text-base 2xl:text-xl md:font-bold"
							>
								User Stories
							</p>
						</div>
					))}
				</Flex>
			</Container>
		</div >
	)
}

export default Stories